import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {globals} from '@extensions/globals-base'

const mediaLinkRus = '/media/video/task-templates-rus-light.mp4'
const mediaLinkEng = '/media/video/task-templates-eng-light.mp4'

const mediaLinkRusDark = '/media/video/task-templates-rus-dark.mp4'
const mediaLinkEngDark = '/media/video/task-templates-eng-dark.mp4'

const TwImageContainer = tw.div`
  py-8
`

const videoMap = {
  ru: {
    light: mediaLinkRus,
    dark: mediaLinkRusDark
  },
  en: {
    light: mediaLinkEng,
    dark: mediaLinkEngDark
  }
}

export const HelpImage = ({className}: {className?: string}) => {
  const lang = Lang.getLang()
  const theme = globals.theme

  const video = videoMap[lang][theme]

  return (
    <TwImageContainer className={className}>
      <video autoPlay loop className="flex rounded-4 w-512 h-512" src={video} />
    </TwImageContainer>
  )
}
